import {globalEnv} from '@chatize-ui/environments/environment.prod'
import {AppCode} from '@chatize-ui/constants/app-code'
import {Environment} from '@chatize-ui/schemes/environment'

export const appEnv: Environment = {
  ...globalEnv,
  appCode: AppCode.Products,
  keycloakConfig: {
    url: 'https://id.containerize.app',
    realm: 'chatize-com',
    clientId: 'products-chatize-com-prod',
  },
}
